import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Steps } from 'primereact/steps';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from "primereact/inputtext";
import { Controller, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import TrendLineTemplate from '../../components/predefinedtemplates/lps/trendLineTemplate';
import BeckersEmailTemplate from '../../components/predefinedtemplates/email/Demand7EmailTemplate';
import BeckersTemplate from '../../components/predefinedtemplates/lps/beckersDemad7';
import { setLPDetails } from '../../slices/createLPSlice';
import IdTemplate from '../../components/predefinedtemplates/lps/IdTemplate';
import NetLinePOC from '../../components/predefinedtemplates/lps/netLineTemplate';
import DefaultEmailTemplate from '../../components/predefinedtemplates/email/DefaultEmailTemplate';
import WebinarEmailTemplate from '../../components/predefinedtemplates/email/WebinarEmailTemplate';
import { unSet } from "../../slices/createLPSlice";
import { setEdit } from "../../slices/authSlice";
import { LandingPageServe } from '../../services/api/LandingPageServ';
import FileUploader from '../../components/FileUploader';


import './EditLp.css'

const EditLp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useRef(null);
  const { id } = useParams();
  const [viewUploader, setViewUploader] = useState(false);
  const [showConfirm, setConfirm] = useState(false);


  const lpDetails = useSelector((state) => state.createLp.data)
  const [lplayout , setLpLayout] = useState(lpDetails.lplayout);

  const [activeIndex, setActiveIndex] = useState(0);

  const getLP = async () => {
    try {
      let data = await LandingPageServe.single(id);
      dispatch(setLPDetails(data));
      reset(data)
    } catch (error) {
      console.log(error)
    } finally {

    }
  }

  useEffect(() => {
    if (!lpDetails._id) {
      getLP()
      setLpLayout(lpDetails.lplayout)
    }
    dispatch(setEdit(true))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lpDetails]);

  const items = [
    {
      label: 'LP Summary'
    },
    // {
    //   label: 'Choose Predefined Landing Page'
    // },
    {
      label: 'Edit Email Page'
    },
    {
      label: 'Edit Landing Page '
    },
  ];


  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue
  } = useForm({ defaultValues: lpDetails });

  const onSubmit = (data) => {
    let payload = { ...data }
    dispatch(setLPDetails(payload));
    setActiveIndex(activeIndex + 1)
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
  };

  const handleNext = () => {
    if (activeIndex === 0) {
      handleSubmit(onSubmit)();
    }
    // if (activeIndex === 1) {
    //   if (!selectedTemplate?.lplayout?.headerLogo) {
    //     toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select any one pre-defined template' });
    //     return;
    //   } else {
    //     dispatch(setLPDetails({ lplayout: selectedTemplate.lplayout, emaillayout: selectedTemplate.emaillayout, fields: selectedTemplate.fields, pdtId: selectedTemplate._id }))
    //   }
    //   setActiveIndex(activeIndex + 1)
    // }
    if (activeIndex === 1) {
      setActiveIndex(activeIndex + 1)
    }

  }

  const handlePrev = () => {
    setActiveIndex(activeIndex - 1)
  }



const saveLP = async (data, status) => {
  try {
    const campaignIds = Array.isArray(data.campaignId)
      ? data.campaignId
          .flatMap(id => String(id).split(','))
          .map(id => id.trim())
          .filter(Boolean)
      : String(data.campaignId || '')
          .split(',')
          .map(id => id.trim())
          .filter(Boolean);

    // Validate Campaign IDs
    if (campaignIds.length === 0) {
      toast.current.show({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please enter at least one Campaign ID.'
      });
      return;
    }

    const uniqueCampaignIds = new Set(campaignIds);

    if (uniqueCampaignIds.size !== campaignIds.length) {
      toast.current.show({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Campaign IDs must be unique.'
      });
      return;
    }

    let payload = {
      ...lpDetails,
      ...data,
      campaignId: campaignIds
    };

    payload.isWebinar = data.lplayout.isWebinar;

    if (status) {
      payload.status = status;
    }

    console.log('Update LP Payload:', payload);

    await LandingPageServe.update(id, payload);

    navigate('../lplist');
    dispatch(unSet());

  } catch (error) {
    console.log(error);

    toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: 'Updation Failed'
    });
  }
};



  const handleDraft = async () => {
    if (lpDetails.name) {
      await saveLP(lpDetails, 'draft')
    }
  }

  const onSave = async (data) => {
    let payload = { ...data }
    dispatch(setLPDetails(payload));
    await saveLP(payload)
  };


  const handleSave = async () => {
    if (activeIndex === 0) {
      handleSubmit(onSave)();
    } else {
      await saveLP(lpDetails)
    }
  }

  const handleUpload = (e) => {
    e.preventDefault();
    setViewUploader(true)
  }

  const handleCloseUploader = (data) => {
    if (data) {
      setValue('thumbnail', data.Location, { shouldValidate: true })
    }
    setViewUploader(false)
  }


  const handleCancel = (e) => {
    setConfirm(true)
  }


  const accept = () => {
    setConfirm(false)
    dispatch(unSet())
    navigate('../lplist')
  }

  const reject = () => {
    setConfirm(false)
  }

  




  const LPDetailsForm = () => {

    return (
      <>
        <div className="grid pt-5">
          <div className="col-6 col-offset-3">
            <Fieldset legend="LP Summary">
              <form>
                <div className="field">
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: 'Asset Name  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          <label htmlFor={field.name}>Asset Name </label>
                        </span>
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="description"
                    control={control}
                    rules={{ required: 'Description  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          <label htmlFor={field.name}>Description </label>
                        </span>
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="assetLink"
                    control={control}
                    rules={{ required: 'Asset  link required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          <label htmlFor={field.name}>Asset Link </label>
                        </span>
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="campaignId"
                    control={control}
                    rules={{ required: 'Campaign ID  is required.' ,
                      
validate: (value) => {
  const campaignIds = (
    Array.isArray(value)
      ? value.flatMap(id => String(id).split(','))
      : String(value ?? '').split(',')
  )
    .map(id => id.trim())
    .filter(Boolean);

  if (campaignIds.length === 0) {
    return 'Please enter at least one Campaign ID.';
  }

  const uniqueCampaignIds = new Set(campaignIds);

  if (uniqueCampaignIds.size !== campaignIds.length) {
    return 'Campaign IDs must be unique.';
  }

  return true;
}

                    }}
                    
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          <label htmlFor={field.name}>Campaign ID (Enter multiple Campaign IDs separated by commas.) </label>
                        </span>
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="campaignName"
                    control={control}
                    rules={{ required: 'Campaign Name  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          <label htmlFor={field.name}>Campaign Name </label>
                        </span>
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="field">
                  <Controller
                    name="client"
                    control={control}
                    rules={{ required: 'Client  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label">
                          <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          <label htmlFor={field.name}>Client </label>
                        </span>
                        {getFormErrorMessage(field.name)}
                      </>
                    )}
                  />
                </div>
                <div className="field p-inputgroup pt-3">
                  <Controller
                    name="thumbnail"
                    control={control}
                    rules={{ required: 'Thumbnail  is required.' }}
                    render={({ field, fieldState }) => (
                      <>
                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                        <span className="p-float-label ">
                          <InputText id={field.name} value={field.value} style={{ borderRadius: "5px" }} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                          <label htmlFor={field.name}>Thumbnail</label>
                        </span>
                      </>
                    )}
                  />
                  <Button label="Upload " onClick={((e) => handleUpload(e))} icon="pi pi-cloud-upload" />
                </div>
                {getFormErrorMessage('thumbnail')}

                {/* 
                <div className="flex justify-content-end">
                  <Button label=" Next " type="submit" outlined />
                </div> */}
              </form>
            </Fieldset>
            <FileUploader open={viewUploader} handleCloseUploader={handleCloseUploader} ></FileUploader>

          </div>
        </div>
      </>
    )
  }


  const EditEmailTemplate = () => {

    return (
       <>
          {
            (lplayout.isWebinar && localStorage.getItem('template_name') !== "Demand7-Becker's Campaign") && <WebinarEmailTemplate></WebinarEmailTemplate>
        }

        {
           (!lplayout.isWebinar && localStorage.getItem('template_name') !== "Demand7-Becker's Campaign") && <DefaultEmailTemplate></DefaultEmailTemplate>
        }

         {
           (localStorage.getItem('template_name') === "Demand7-Becker's Campaign") && <BeckersEmailTemplate></BeckersEmailTemplate>
        }
      </>
    )
  }

  const EditTemplate = () => {

    return (
  <>
        { localStorage.getItem('template_name') === 'ID Template' ? (
          <IdTemplate></IdTemplate>
      ) :  (localStorage.getItem('template_name') === 'NetLine Template' || localStorage.getItem('template_name') === 'NL Template') ? (
        <NetLinePOC></NetLinePOC>
      ) : (localStorage.getItem('template_name') === 'Trendline ID Template' || localStorage.getItem('template_name') === 'Trendline Template') ? (
        <TrendLineTemplate></TrendLineTemplate>
      ) :(localStorage.getItem('template_name') === "Demand7-Becker's Campaign" || localStorage.getItem('template_name') === "Demand7-Becker's Campaign") ? (
        <BeckersTemplate></BeckersTemplate>
      ) : (
        <p>Template Not found</p>
      )}
        </>
    )
  }



  return (
    <>
      <Toast ref={toast} />
      <div className="card">
        <div className='flex justify-content-between '>
          <div className='flex justify-content-end gap-3 pb-1'>
            {activeIndex !== 0 && <Button label="Prev" severity="info" size="small" outlined onClick={handlePrev} />}
            {activeIndex !== 4 && <Button label="Next" severity="info" size="small" outlined onClick={handleNext} />}
          </div>
          <div className='flex justify-content-end gap-3 pb-1'>
            <Button label="Cancel" severity="danger" size="small" outlined onClick={handleCancel} />
            <Button label="Draft" severity="info" size="small" outlined onClick={handleDraft} />
            <Button label="Update" severity="success" size="small" outlined onClick={handleSave} />
          </div>
        </div>
        <ConfirmDialog
          group="declarative"
          visible={showConfirm}
          onHide={() => setConfirm(false)}
          message="Are you sure you want to cancel?"
          header="Confirmation"
          icon="pi pi-exclamation-triangle"
          accept={accept}
          reject={reject}
          style={{ width: '50vw' }}
          breakpoints={{ '1100px': '75vw', '960px': '100vw' }}
        />
        <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} />
        {activeIndex === 0 && <LPDetailsForm />}
        {/* {activeIndex === 1 && <ChooseTemplate />} */}
        {activeIndex === 1 && <EditEmailTemplate />}
        {activeIndex === 2 && <EditTemplate />}
      </div>
    </>

  )
}

export default EditLp